export default "__VITE_ASSET__81518e55__"